import { SideSheetBody, SideSheetHeader } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const SideSheetCloseContainer = styled.div`
  position: absolute;
  z-index: 2;
  ${({ theme }) => css`
    right: -${theme.spacings[400]};
    top: ${theme.spacings[200]};
  `}
`;

export const SideSheetHeaderStyled = styled(SideSheetHeader)`
  padding: 0;
`;

export const SideSheetBodyStyled = styled(SideSheetBody)`
  flex-direction: column;
`;
